import { render, staticRenderFns } from "./criminal-law-part-2.vue?vue&type=template&id=11c45220&"
import script from "./criminal-law-part-2.vue?vue&type=script&lang=js&"
export * from "./criminal-law-part-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports